import { useAuthStore } from '@/stores/auth';
import { useRouterStore } from '@/stores/router';
import { useToastNotificacao } from 'nemesiselements';
import { ehErroSessao, ehErroSilenciado, mensagemErroApi } from '@/commons/erroApi';
import router from '@/router';

export const useErrorHandler = () => {
    const authStore = useAuthStore();
    const routerStore = useRouterStore();

    const handleApiError = (error, options = {}) => {
        const {
            defaultMessage = 'Não foi possível carregar os dados',
            unauthorizedMessage = 'Usuário não tem permissão para acessar a página',
            redirectOnError = true
        } = options;

        // Erro na esteira de outro já avisado: a tela toda cai junto no 401
        if (ehErroSilenciado(error)) return;

        const { erro } = useToastNotificacao();

        // Mensagem do backend (ex.: "não é coordenador do projeto") no lugar do texto padrão
        const mensagemApi = mensagemErroApi(error);

        // O interceptor já encerrou a sessão e mandou para o login: aqui só falta o aviso
        if (ehErroSessao(error)) {
            erro(mensagemApi || unauthorizedMessage);
            return;
        }

        if (error.response?.status === 401 && routerStore.rotaAtual.name !== 'login') {
            erro(mensagemApi || unauthorizedMessage);

            const { name, params } = routerStore.ultimaRotaVisitada || {};

            if (!name || name === 'login') {
                authStore.logout();
                router.push({ name: 'login' });
            } else {
                router.push({ name, ...(params?.id != null ? { params: { id: params.id } } : {}) });
            }
        } else {
            if (routerStore.rotaAtual.name !== 'login') {
                erro(mensagemApi || defaultMessage);
            }

            if (redirectOnError && routerStore.rotaAtual.name !== 'login') {
                router.back();
            }
        }
    };

    const handleFormError = (error, customMessage) => {
        if (ehErroSilenciado(error)) return;

        const { erro, aviso } = useToastNotificacao();
        const message = customMessage || mensagemErroApi(error) || 'Não foi possível processar a solicitação';

        if (error.response?.status === 406) {
            aviso(message);
        } else {
            erro(message);
        }
    };

    const handleSuccess = (message) => {
        const { sucesso } = useToastNotificacao();
        sucesso(message);
    };

    return {
        handleApiError,
        handleFormError,
        handleSuccess
    };
};
